<template>
  <div class="nx-list-page contract-pay-whitelist-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAdd">新增</el-button>
        <el-button
          type="primary"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
      </template>

      <template slot="contractNo" slot-scope="{ row }">
        <span>{{ row.contractNo || '-' }}</span>
      </template>

      <template slot="status" slot-scope="{ row }">
        <matrix-tag :color="statusColor(row.status)" :text="statusLabel(row.status)" />
      </template>

      <template slot="remark" slot-scope="{ row }">
        <span>{{ row.remark || '-' }}</span>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" @click="openEdit(row)">编辑备注</el-button>
        <el-button type="text" size="small" @click="handleToggleStatus(row)">
          {{ isEnabled(row.status) ? '停用' : '启用' }}
        </el-button>
        <el-button type="text" size="small" class="danger-text" @click="handleRemove(row)">移出</el-button>
      </template>
    </avue-crud>

    <el-dialog
      title="新增合同费用白名单"
      :visible.sync="addVisible"
      width="560px"
      append-to-body
      @closed="resetAddForm"
    >
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="100px">
        <el-form-item label="合同" prop="contractNo">
          <el-select
            v-model="addForm.contractNo"
            class="form-block"
            filterable
            remote
            reserve-keyword
            clearable
            placeholder="请输入合同编号或名称检索"
            :remote-method="remoteContractSearch"
            :loading="contractLoading"
            @change="handleContractChange"
          >
            <el-option
              v-for="item in contractOptions"
              :key="contractOptionKey(item)"
              :label="contractOptionLabel(item)"
              :value="item.contractNo"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="合同名称">
          <el-input v-model="addForm.contractName" disabled />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="addForm.remark" type="textarea" :rows="3" maxlength="200" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitLoading" @click="handleAddSubmit">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑备注"
      :visible.sync="editVisible"
      width="520px"
      append-to-body
      @closed="resetEditForm"
    >
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="合同编号">
          <el-input v-model="editForm.contractNo" disabled />
        </el-form-item>
        <el-form-item label="合同名称">
          <el-input v-model="editForm.contractName" disabled />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" :rows="3" maxlength="200" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitLoading" @click="handleEditSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins';
import matrixTag from '@/components/matrix/matrix-tag';
import { downloadXls } from '@/util/util';
import {
  getList,
  add,
  update,
  updateStatus,
  remove,
  exportExcel,
  selectTransportContracts,
} from './api';

const STATUS_ENABLED = 1;
const STATUS_DISABLED = 0;
const STATUS_OPTIONS = [
  { label: '启用', value: STATUS_ENABLED },
  { label: '停用', value: STATUS_DISABLED },
];

function createAddForm() {
  return {
    contractId: '',
    contractNo: '',
    contractName: '',
    remark: '',
  };
}

function createEditForm() {
  return {
    id: '',
    contractId: '',
    contractNo: '',
    contractName: '',
    remark: '',
  };
}

export default {
  name: 'finance-contract-pay-whitelist',
  components: { matrixTag },
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      exportLoading: false,
      submitLoading: false,
      contractLoading: false,
      addVisible: false,
      editVisible: false,
      contractOptions: [],
      addForm: createAddForm(),
      editForm: createEditForm(),
      addRules: {
        contractNo: [{ required: true, message: '请选择合同', trigger: 'change' }],
        remark: [{ max: 200, message: '备注最多 200 个字符', trigger: 'blur' }],
      },
      editRules: {
        remark: [{ max: 200, message: '备注最多 200 个字符', trigger: 'blur' }],
      },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 190,
        labelWidth: 110,
        column: [
          {
            label: '合同编号',
            prop: 'contractNo',
            slot: true,
            search: true,
            minWidth: 170,
            overHidden: true,
          },
          {
            label: '合同名称',
            prop: 'contractName',
            search: true,
            minWidth: 180,
            overHidden: true,
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            slot: true,
            search: true,
            width: 90,
            dicData: STATUS_OPTIONS,
          },
          {
            label: '备注',
            prop: 'remark',
            slot: true,
            minWidth: 180,
            overHidden: true,
          },
          {
            label: '加入人',
            prop: 'createName',
            width: 110,
            overHidden: true,
          },
          {
            label: '加入时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 170,
          },
          {
            label: '更新人',
            prop: 'updateName',
            width: 110,
            overHidden: true,
          },
          {
            label: '更新时间',
            prop: 'updateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 170,
          },
          {
            label: '加入时间',
            prop: 'searchDate',
            type: 'datetime',
            search: true,
            searchSpan: 9,
            hide: true,
            showColumn: false,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
            searchRange: true,
            defaultTime: ['00:00:00', '23:59:59'],
            clearable: true,
            paramsKey: ['startTime', 'endTime'],
          },
        ],
      },
    };
  },
  methods: {
    isEnabled(status) {
      return Number(status) === STATUS_ENABLED;
    },
    statusLabel(status) {
      const item = STATUS_OPTIONS.find((option) => Number(option.value) === Number(status));
      return item ? item.label : status;
    },
    statusColor(status) {
      return this.isEnabled(status) ? '#166534' : '#64748b';
    },
    openAdd() {
      this.addVisible = true;
      this.remoteContractSearch('');
    },
    openEdit(row) {
      this.editForm = {
        id: row.id,
        contractId: row.contractId,
        contractNo: row.contractNo,
        contractName: row.contractName,
        remark: row.remark || '',
      };
      this.editVisible = true;
    },
    resetAddForm() {
      this.addForm = createAddForm();
      this.contractOptions = [];
      this.$refs.addForm && this.$refs.addForm.clearValidate();
    },
    resetEditForm() {
      this.editForm = createEditForm();
      this.$refs.editForm && this.$refs.editForm.clearValidate();
    },
    contractOptionKey(item) {
      return item.id || item.contractId || item.contractNo;
    },
    contractOptionLabel(item) {
      return [item.contractNo, item.contractName].filter(Boolean).join(' / ');
    },
    async remoteContractSearch(keyword) {
      this.contractLoading = true;
      try {
        const baseParams = {
          page: 1,
          size: 20,
          payWhitelistSelectable: 1,
        };
        let records = [];
        if (keyword) {
          const noRes = await selectTransportContracts({ ...baseParams, contractNo: keyword });
          const noData = noRes.data.data || {};
          records = noData.records || [];
          if (records.length < 1) {
            const nameRes = await selectTransportContracts({ ...baseParams, contractName: keyword });
            const nameData = nameRes.data.data || {};
            records = nameData.records || [];
          }
        } else {
          const res = await selectTransportContracts(baseParams);
          const data = res.data.data || {};
          records = data.records || [];
        }
        this.contractOptions = records;
      } catch (e) {
        console.warn(e);
        this.contractOptions = [];
        this.$message.error('合同检索失败');
      } finally {
        this.contractLoading = false;
      }
    },
    handleContractChange(contractNo) {
      const hit = this.contractOptions.find((item) => item.contractNo === contractNo);
      if (!hit) {
        this.addForm.contractId = '';
        this.addForm.contractName = '';
        return;
      }
      this.addForm.contractId = hit.id || hit.contractId || '';
      this.addForm.contractName = hit.contractName || '';
    },
    handleAddSubmit() {
      this.$refs.addForm.validate(async (valid) => {
        if (!valid) return;
        this.submitLoading = true;
        try {
          await add({ ...this.addForm });
          this.$message.success('新增成功');
          this.addVisible = false;
          this.refreshChange();
        } finally {
          this.submitLoading = false;
        }
      });
    },
    handleEditSubmit() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return;
        this.submitLoading = true;
        try {
          await update({ ...this.editForm });
          this.$message.success('保存成功');
          this.editVisible = false;
          this.refreshChange();
        } finally {
          this.submitLoading = false;
        }
      });
    },
    handleToggleStatus(row) {
      const nextStatus = this.isEnabled(row.status) ? STATUS_DISABLED : STATUS_ENABLED;
      const actionText = nextStatus === STATUS_ENABLED ? '启用' : '停用';
      this.$confirm(`确定${actionText}该合同白名单吗？`, '提示', { type: 'warning' }).then(async () => {
        this.loading = true;
        try {
          await updateStatus({
            id: row.id,
            contractNo: row.contractNo,
            status: nextStatus,
          });
          this.$message.success(`${actionText}成功`);
          this.refreshChange();
        } finally {
          this.loading = false;
        }
      }).catch(() => {});
    },
    handleRemove(row) {
      this.$confirm('确定将该合同移出费用白名单吗？', '提示', { type: 'warning' }).then(async () => {
        this.loading = true;
        try {
          await remove({
            id: row.id,
            contractNo: row.contractNo,
          });
          this.$message.success('移出成功');
          this.refreshChange();
        } finally {
          this.loading = false;
        }
      }).catch(() => {});
    },
    async handleExport() {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出');
        return;
      }
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `合同费用白名单_${Date.now()}.xlsx`);
        this.$message.success('导出成功');
      } catch (e) {
        console.warn(e);
        this.$message.error((e && e.message) || '导出失败');
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form-block {
  width: 100%;
}

.danger-text {
  color: #f56c6c;
}
</style>
